import React from 'react';
import { Star, Quote, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TestimonialsSection = () => {
  const { t } = useTranslation();
  const testimonials = [
    {
      id: 't1',
      name: 'Davide Ferretti',
      role: 'CEO',
      company: 'SolarTech Italia',
      location: 'Milano',
      image: 'https://images.unsplash.com/photo-1640531005099-e44dde94945a?w=100&h=100&fit=crop&crop=face',
      rating: 5,
    },
    {
      id: 't2',
      name: 'Chiara Mantovani',
      role: 'Marketing Manager',
      company: 'EdilSmart',
      location: '',
      image: 'https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?w=100&h=100&fit=crop&crop=face',
      rating: 5,
    },
    {
      id: 't3',
      name: 'Luca Parisi',
      role: 'Founder',
      company: 'WebAgency Pro',
      location: '',
      image: 'https://images.unsplash.com/photo-1640531005390-38bd92755d6a?w=100&h=100&fit=crop&crop=face',
      rating: 5,
    },
  ];

  return (
    <section className="py-24 px-6" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-up">
          <span className="text-xs uppercase tracking-[0.2em] text-[#0055FF] font-semibold">{t('testimonials.eyebrow')}</span>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-medium tracking-tight mt-4 mb-6">
            {t('testimonials.title')}
          </h2>
          <p className="text-lg text-[#A1A1AA] max-w-2xl mx-auto">{t('testimonials.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="card-bento animate-fade-up flex flex-col"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`testimonial-card-${index}`}
            >
              <Quote className="w-10 h-10 text-[#0055FF]/30 mb-6 flex-shrink-0" />

              <p className="text-[#d4d4d8] leading-relaxed mb-6 flex-1">
                "{t('testimonials.items.' + testimonial.id + '.content')}"
              </p>

              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-[#0055FF]/8 border border-[#0055FF]/20 mb-6">
                <TrendingUp className="w-4 h-4 text-[#0055FF] flex-shrink-0" />
                <span className="text-sm text-[#60a5fa] font-medium">{t('testimonials.items.' + testimonial.id + '.stat')}</span>
              </div>

              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-[#F59E0B] fill-[#F59E0B]" />
                ))}
              </div>

              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <div className="font-['Outfit'] font-medium">{testimonial.name}</div>
                  <div className="text-sm text-[#A1A1AA]">
                    {testimonial.role} · {testimonial.company}
                    {testimonial.location && ` · ${testimonial.location}`}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 p-8 rounded-3xl bg-[#111111] border border-white/10">
          {[
            { value: '2', labelKey: 'testimonials.stats.engines' },
            { value: '8', labelKey: 'testimonials.stats.aiEngines' },
            { value: '24/7', labelKey: 'testimonials.stats.alwaysOn' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl md:text-4xl font-['Outfit'] font-semibold text-gradient">{stat.value}</div>
              <div className="text-sm text-[#A1A1AA] mt-1">{t(stat.labelKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
